module.exports = __webpack_public_path__ + "img/trips-1-mobile.25e02278.gif";